window.LogbookAPI = new (function () {

    var self = this;
    var _protected = BaseAPI.call(self);

    _protected.setApiUrl(publicConfiguration['Logbook']);

    self.getServiceSettings = function (brandId) {
        var defer = $q.defer();
        _protected.request("brands/" + brandId + "/settings", "GET")
            .then(function (res) {
                if (res && res.data && res.data.data) {
                    defer.resolve(res.data.data);
                } else {
                    defer.reject();
                }
            }, function (err) {
                defer.reject(err);
            });
        return defer.promise;
    };

    self.updateServiceSettings = function (brandId, params) {
        var defer = $q.defer();
        _protected.request("brands/" + brandId + "/settings", "PATCH", params)
            .then(function (res) {
                defer.resolve(res);
            }, function (err) {
                defer.reject(err);
            });
        return defer.promise;
    };

    self.createLogbookTag = function (brandId, params) {
        var defer = $q.defer();
        _protected.request("brands/" + brandId + "/settings/tags", "POST", params).then(function (res) {
            if (res && res.data && res.data.data) {
                defer.resolve(res);
            } else {
                defer.reject();
            }
        }, function (err) {
            if(err && err.data && err.data.errors && err.data.errors[0]){
                defer.reject(err.data.errors[0]);
            }else{
                defer.reject(null);
            }
        });
        return defer.promise;
    };

    self.getLogbookTags = function (brandId) {
        var defer = $q.defer();
        _protected.request("brands/" + brandId + "/settings/tags", "GET")
            .then(function (res) {
                if (res && res.data && res.data.data && res.data.data.tags) {
                    defer.resolve(res.data.data.tags);
                } else {
                    defer.reject();
                }
            }, function (err) {
                defer.reject(err);
            });
        return defer.promise;
    };

    self.getLogbookEntriesTypes = function (brandId) {
        var defer = $q.defer();
        _protected.request("brands/" + brandId + "/entries/types", "GET")
            .then(function (res) {
                if (res && res.data && res.data.data && res.data.data.entries_types) {
                    defer.resolve(res.data.data.entries_types);
                } else {
                    defer.reject();
                }
            }, function (err) {
                defer.reject(err);
            });
        return defer.promise;
    };

    self.getLogbookEntriesTags = function (brandId) {
        var defer = $q.defer();
        _protected.request("brands/" + brandId + "/entries/tags", "GET")
            .then(function (res) {
                if (res && res.data && res.data.data && res.data.data.tags) {
                    defer.resolve(res.data.data.tags);
                } else {
                    defer.reject();
                }
            }, function (err) {
                defer.reject(err);
            });
        return defer.promise;
    };

    self.updateLogbookTag = function (brandId, tagId, params) {
        var defer = $q.defer();
        _protected.request("brands/" + brandId + "/settings/tags/" + tagId, "PUT", params)
            .then(function (res) {
                defer.resolve(res);
            }, function (err) {
                if(err && err.data && err.data.errors && err.data.errors[0]){
                    defer.reject(err.data.errors[0]);
                }else{
                    defer.reject(null);
                }
            });
        return defer.promise;
    };

    self.getEntryTypes = function (brandId, params) {
        var defer = $q.defer();
        _protected.request("brands/" + brandId + "/settings/entries/types", "GET", params)
            .then(function (res) {
                if (res && res.data && res.data.data && res.data.data.entries_types) {
                    defer.resolve(res.data.data.entries_types);
                } else {
                    defer.reject();
                }
            }, function (err) {
                defer.reject(err);
            });
        return defer.promise;
    };

    self.createEntryType = function (brandId, params) {
        var defer = $q.defer();
        _protected.request("brands/" + brandId + "/settings/entries/types", "POST", params).then(function (res) {
            if (res && res.data && res.data.data) {
                defer.resolve(res);
            } else {
                defer.reject();
            }
        }, function (err) {
            if(err && err.data && err.data.errors && err.data.errors[0]){
                defer.reject(err.data.errors[0]);
            }else{
                defer.reject(null);
            }
        });
        return defer.promise;
    };

    self.updateEntryType = function (brandId, typeId, params) {
        var defer = $q.defer();
        _protected.request("brands/" + brandId + "/settings/entries/types/" + typeId, "PUT", params).then(function (res) {
            defer.resolve(res);
        }, function (err) {
            if(err && err.data && err.data.errors && err.data.errors[0]){
                defer.reject(err.data.errors[0]);
            }else{
                defer.reject(null);
            }
        });
        return defer.promise;
    };


    self.getLogbookNotificationsSettings = function (brandId) {
        var defer = $q.defer();
        _protected.request("brands/" + brandId + "/settings/entries/types/summary_notifications", "GET")
            .then(function (res) {
                if (res && res.data && res.data.data && res.data.data.summary_notifications) {
                    defer.resolve(res.data.data.summary_notifications);
                } else {
                    defer.reject();
                }
            }, function (err) {
                defer.reject(err);
            });
        return defer.promise;
    };

    self.updateLogbookNotificationsSettings = function (brandId, params) {
        var defer = $q.defer();
        _protected.request("brands/" + brandId + "/settings/entries/types/summary_notifications", "PUT", params).then(function (res) {
            defer.resolve(res);
        }, function (err) {
            defer.reject(err);
        });
        return defer.promise;
    };

    self.getTypeUsers = function (brandId, typeId) {
        var defer = $q.defer();
        _protected.request("brands/" + brandId + "/entries/types/" + typeId + '/users', "GET")
            .then(function (res) {
                if (res && res.data && res.data.data && res.data.data.users) {
                    defer.resolve(res.data.data.users);
                } else {
                    defer.reject();
                }
            }, function (err) {
                defer.reject(err);
            });
        return defer.promise;
    };

    self.getLogbookEntriesReportData = function (brandId, params) {
        var defer = $q.defer();
        _protected.request("reports/brands/" + brandId + "/entries", "GET", params).then(function (res) {
            if (res && res.data && res.data.data && res.data.data.entries) {
                defer.resolve(res.data.data.entries);
            } else {
                defer.reject();
            }
        }, function (err) {
            defer.reject(err);
        });
        return defer.promise;
    };

    self.getEntriesReportBrandStats = function (brandId, params) {
        var defer = $q.defer();
        _protected.request("reports/brands/" + brandId + "/entries/stats", "GET", params).then(function (res) {
            if (res && res.data && res.data.data && res.data.data.brands) {
                defer.resolve(res.data.data.brands);
            } else {
                defer.reject();
            }
        }, function (err) {
            defer.reject(err);
        });
        return defer.promise;
    };

    self.getEntryDetails = function (brandId, entryId) {
        var defer = $q.defer();
        _protected.request("brands/" + brandId + "/entries/" + entryId, "GET").then(function (res) {
            if (res && res.data && res.data.data && res.data.data.entry) {
                defer.resolve(res.data.data.entry);
            } else {
                defer.reject();
            }
        }, function (err) {
            defer.reject(err);
        });
        return defer.promise;
    };

    self.getTasksReportBrandStats = function (brandId, params) {
        var defer = $q.defer();
        _protected.request("reports/brands/" + brandId + "/tasks/stats", "GET", params).then(function (res) {
            if (res && res.data && res.data.data && res.data.data.brands) {
                defer.resolve(res.data.data.brands);
            } else {
                defer.reject();
            }
        }, function (err) {
            defer.reject(err);
        });
        return defer.promise;
    };

    self.getLogbookTasksReportData = function (brandId, params) {
        var defer = $q.defer();
        _protected.request("reports/brands/" + brandId + "/tasks", "GET", params).then(function (res) {
            if (res && res.data && res.data.data && res.data.data.tasks) {
                defer.resolve(res.data.data.tasks);
            } else {
                defer.reject();
            }
        }, function (err) {
            defer.reject(err);
        });
        return defer.promise;
    };

    self.getTaskDetails = function (brandId, taskId) {
        var defer = $q.defer();
        _protected.request("brands/" + brandId + "/tasks/" + taskId, "GET").then(function (res) {
            if (res && res.data && res.data.data && res.data.data.task) {
                defer.resolve(res.data.data.task);
            } else {
                defer.reject();
            }
        }, function (err) {
            defer.reject(err);
        });
        return defer.promise;
    };

    self.getCheckListsReportBrandStats = function (brandId, params) {
        var defer = $q.defer();
        _protected.request("reports/brands/" + brandId + "/checklists/stats", "GET", params).then(function (res) {
            if (res && res.data && res.data.data && res.data.data.brands) {
                defer.resolve(res.data.data.brands);
            } else {
                defer.reject();
            }
        }, function (err) {
            defer.reject(err);
        });
        return defer.promise;
    };

    self.getLogbookCheckListsReportData = function (brandId, params) {
        var defer = $q.defer();
        _protected.request("reports/brands/" + brandId + "/checklists", "GET", params).then(function (res) {
            if (res && res.data && res.data.data && res.data.data.checklists) {
                defer.resolve(res.data.data.checklists);
            } else {
                defer.reject();
            }
        }, function (err) {
            defer.reject(err);
        });
        return defer.promise;
    };

    self.getCheckListDetails = function (brandId, checkListId) {
        var defer = $q.defer();
        _protected.request("brands/" + brandId + "/checklists/" + checkListId, "GET").then(function (res) {
            if (res && res.data && res.data.data && res.data.data.checklist) {
                defer.resolve(res.data.data.checklist);
            } else {
                defer.reject();
            }
        }, function (err) {
            defer.reject(err);
        });
        return defer.promise;
    };

    self.getLogbookActions = (brandId) => {
        const defer = $q.defer();

        _protected.request(`brands/${brandId}/actions`,"GET").then((res) => {
            if (res?.data?.data) {
                defer.resolve(res.data.data);
            } else {
                defer.reject();
            }
        }, function (err) {
            defer.reject(err);
        });
        return defer.promise;
    }

    self.getDashboardStats = function (brandId, params) {
        var defer = $q.defer();

        _protected.request("brands/" + brandId + "/stats","GET",params).then(function (res) {
            if (res && res.data && res.data.data) {
                defer.resolve(res.data.data);
            } else {
                defer.reject();
            }
        }, function (err) {
            defer.reject(err);
        });
        return defer.promise;
    }

});